import React, { forwardRef, useEffect, useState } from "react";
import Header from "../../Image/Header1.png";
import Fotter from "../../Image/Footer1.png";
const PrintableComponent = forwardRef((props, ref) => {
  const forms = props.forms;
  const followUp = props.followUp;
  const visit = props.visit;
  const [surgeryId, setSurgeryId] = useState([]);
  const [typeSurgeryId, setTypeSurgeryId] = useState([]);

  const [TYPId, setTYPId] = useState([]);
  const [organLevelId, setOrganLevelId] = useState([]);
  const [doctorId, setDoctorId] = useState([]);

  const [typeOfHelp, setTypeOfHelp] = useState([]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  // console.log();
  const [inputValue, setInputValue] = useState({});
  useEffect(() => {
    let tempInputValue = {};

    if (followUp?.length > 0) {
      const updatedTypeOfHelp = followUp[0]?.type_of_help.map((type) => ({
        label: type,
        value: type,
      }));
      setTypeOfHelp([...typeOfHelp, ...updatedTypeOfHelp]);

      if (followUp[0]?.doctor) {
        const updatedDoctorId = followUp[0].doctor.map((doctor) => ({
          label: doctor,
          value: doctor,
        }));
        setDoctorId([...doctorId, ...updatedDoctorId]);
      }

      if (followUp[0]?.TYP) {
        const updatedTYPId = followUp[0].TYP.map((TYP) => ({
          label: TYP,
          value: TYP,
        }));
        setTYPId([...TYPId, ...updatedTYPId]);
      }

      if (followUp[0]?.disease_type_specialist) {
        const updatedSurgeryId = followUp[0].disease_type_specialist.map(
          (diseaseType) => ({
            label: diseaseType,
            value: diseaseType,
          })
        );
        setSurgeryId([...surgeryId, ...updatedSurgeryId]);
      }

      if (followUp[0]?.organ) {
        const updatedTypeSurgeryId = followUp[0].organ.map((organ) => ({
          label: organ,
          value: organ,
        }));
        setTypeSurgeryId([...typeSurgeryId, ...updatedTypeSurgeryId]);
      }

      if (followUp[0]?.organ_level) {
        const updatedOrganLevelId = followUp[0].organ_level.map((organ) => ({
          label: organ,
          value: organ,
        }));
        setOrganLevelId([...organLevelId, ...updatedOrganLevelId]);
      }

      followUp.map((follow) => {
        tempInputValue[follow.type] = follow.note;
      });
    } else {
      forms.forEach((form) => {
        form.sectionForm.forEach((section) => {
          section.field.forEach((field) => {
            tempInputValue[field.name] = "";
          });
        });
      });
    }
    setInputValue(tempInputValue);
  }, [followUp, forms, visit]);
  return (
    <div className="px-4" ref={ref}>
      <img src={Header} alt="Header" className="print-header-image" />

      <div className="flex justify-center gap-4" dir="rtl">
        <div className="flex flex-col">
          <label>
            ناو

          </label>

          <input type="text" name="name" className="p-1 input text-right border-black" value={visit?.patient?.patient_info?.fullname} />
        </div>

        <div className="flex flex-col">
          <label>
            ڕەگەز

          </label>

          <input type="text" name="name" className="p-1 input text-right border-black" value={visit?.patient?.patient_info?.gender} />
        </div>
        <div className="flex flex-col">
          <label>
            ژ.مۆبایل

          </label>

          <input type="text" name="name" className="p-1 input text-right border-black" value={visit?.patient?.patient_info?.phone} />
        </div>
        <div className="flex flex-col">
          <label>
            ڕۆژی لەدایکبوون
          </label>

          <input type="text" name="name" className="p-1 input text-right border-black" value={visit?.patient?.patient_info?.birth_date} />
        </div>

      </div>
      <form action="">
        {forms?.map((form, formIndex) => {
          return form.sectionForm.map((section, sectionIndex) => {
            return (
              <div key={sectionIndex + formIndex}>
                <div className="bg-teal-500 p-1 w-3/12 my-1 m-auto rounded-sm text-white text-center shadow-md">
                  {section.title}
                </div>
                <div className="grid grid-cols-4 gap-3 my-2">
                  {section.field.map((field, index) => {
                    return (
                      <div key={index} className="flex flex-col text-right">
                        {/* {field.type} */}
                        <div>
                          {field.type === "textarea" ? (
                            ""
                          ) : (
                            <label htmlFor="" className="text-sm">* {field.label} </label>
                          )}
                        </div>
                        {field.type === "textarea" ? (
                          ""
                        ) : field.type === "dropdown" ? (
                          <select
                            className="p-1 border-black"
                            type={field.type}
                            name={field.name}
                            placeholder={field.placeholder}
                            onChange={handleInputChange}
                            value={inputValue[field.name]}
                          >
                            <option value="">تکایە زانیاریەکە هەڵبژێرە</option>
                            {field?.drop_down.map((dropdown, index) => {
                              return (
                                <option value={dropdown.value} key={index}>
                                  {dropdown.value}
                                </option>
                              );
                            })}
                          </select>
                        ) : (
                          <input
                            type={field.type}
                            name={field.name}
                            placeholder={field.placeholder}
                            onChange={handleInputChange}
                            value={inputValue[field.name]}
                            className="p-1 input text-right border-black"
                          />
                        )}
                      </div>
                    );
                  })}
                </div>
              </div>
            );
          });
        })}

        <div className="grid grid-cols-4 gap-2">
          <div className="w-full flex flex-col">
            <div>
              <label htmlFor="">Doctor *</label>
            </div>
            <input
              type="text"
              className="input w-full border-black"
              value={doctorId.map((doctor) => doctor.label).join(", ")}
            />
          </div>
          <div className="w-full flex flex-col">
            <div className="">
              <label htmlFor="">Disease type specialist *</label>
            </div>
            <input
              type="text"
              className="input w-full border-black"
              value={surgeryId.map((surgery) => surgery.label).join(", ")}
            />
          </div>
          <div className="w-full flex flex-col">
            <div>Organ *</div>
            <input
              type="text"
              className="input w-full border-black"
              value={typeSurgeryId.map((surgery) => surgery.label).join(", ")}
            />
          </div>
          <div className="w-full flex flex-col">
            <div>TYP *</div>
            <input
              type="text"
              className="input w-full border-black"
              value={TYPId.map((typ) => typ.label).join(", ")}
            />
          </div>
          <div className="w-full flex flex-col">
            <div>Organ Level *</div>
            <input
              type="text"
              className="input w-full border-black"
              value={organLevelId.map((organ) => organ.label).join(", ")}
            />
          </div>
        </div>
      </form>
      <footer className="w-full   absolute bottom-0">
        <img src={Fotter} alt="Footer" className="w-full absolute bottom-0" />
      </footer>
    </div>
  );
});

export default PrintableComponent;
